// extracted by mini-css-extract-plugin
export default {"overlay":"HC-z","bodyOpen":"IC-z","content":"JC-z","header":"KC-z","close":"LC-z","closeNoHeading":"MC-z"};